import type { HttpContext, HttpParams } from '@angular/common/http';
import type { ClassProvider } from '@angular/core';

import type { Observable } from 'rxjs';

export interface AuthConfigI {
  authUrl: string;
  appUrl: string;
  webAppUrl: string;
  hasHttps: boolean;
}

export enum CookieKey {
  SuperadminAccessToken = 'superadmin_access_token',
  AccessToken = 'access_token',
  AccessTokenExpiresAt = 'access_token_expires_at',
  Company = 'company',
  OrgGuid = 'org_guid',
}

export interface HttpApiRequestOptions {
  headers?:
    | (Record<string, string | []> & {
        'x-json-accent'?: 'snake' | 'pascal' | 'camel' | [];
      } & IdentityHeaders)
    | {};
  skipURLBuild?: boolean;
  responseType?: 'json' | 'text';
  addToken?: boolean;
  skipCompany?: boolean;
  httpContext?: HttpContext;
}

export enum IdentityHeader {
  Client = 'x-recruitee-client',
  Env = 'x-recruitee-env',
  RealtimeEvent = 'x-recruitee-realtime-event',
  Startup = 'x-recruitee-startup',
  TsApp = 'x-ts-app',
  TsOrg = 'x-ts-org',
  TsAnalytics = 'x-tellent-analytics-client',
}

export type IdentityHeaders = Partial<Record<IdentityHeader, string>>;

export abstract class HttpRequestData {
  public abstract buildUrl(path: string, requestOptions?: HttpApiRequestOptions): string;
  public provideAuthHeaders(): { Authorization: string } | {} {
    return {};
  }
  public buildSignedUrl(path: string, search?: HttpParams): string | null {
    return null;
  }
  public abstract provideIdentityHeaders(isE2e: boolean): IdentityHeaders;
}

export interface HttpRequestDataProvider extends ClassProvider {
  provide: typeof HttpRequestData;
}

export interface HttpApi {
  get: <R = any>(
    path: string,
    params?: any,
    options?: HttpApiRequestOptions | null,
  ) => Observable<R>;

  post: <R = any>(
    path: string,
    params?: any,
    body?: object | null,
    options?: HttpApiRequestOptions | null,
    progressEmitterUuid?: string | null,
  ) => Observable<R>;

  put: <R = any>(
    path: string,
    params?: any,
    body?: object,
    options?: HttpApiRequestOptions,
  ) => Observable<R>;

  patch: <R = any>(
    path: string,
    params?: any,
    body?: object | null,
    options?: HttpApiRequestOptions,
  ) => Observable<R>;

  delete: <R = any>(path: string, params?: any, options?: HttpApiRequestOptions) => Observable<R>;
}
